import React, { CSSProperties, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
// tslint:disable-next-line:import-name
import Highlighter from 'react-highlight-words';

// tslint:disable-next-line:import-name
import style from './index.module.css';

export interface FontAwesomeTileProps {
  icon: IconDefinition;
  label?: string;
  size?: SizeProp;
  topLeftLabel?: ReactNode;
  topRightLabel?: ReactNode;
  bottomLeftLabel?: ReactNode;
  bottomRightLabel?: ReactNode;
  color?: CSSProperties['color'];
  className?: string;
  highlight?: string;
  onClick?: () => void;
}

// tslint:disable-next-line:function-name
export default function FontAwesomeTile({
  icon,
  label,
  size = '3x',
  topLeftLabel,
  topRightLabel,
  bottomLeftLabel,
  bottomRightLabel,
  className,
  color,
  highlight,
  onClick,
}: FontAwesomeTileProps) {
  return <div
    className={`${style.FontAwesomeTile} ${className || ''}`}
    onClick={onClick}
    style={{ cursor: onClick ? 'pointer' : undefined }}
  >
    <div>
      <FontAwesomeIcon icon={icon} size={size} color={color} />
      <b className={`${style.LeftLabel} ${style.TopLabel}`}>{topLeftLabel}</b>
      <b className={`${style.RightLabel} ${style.TopLabel}`}>{topRightLabel}</b>
      <b className={`${style.LeftLabel} ${style.BottomLabel}`}>{bottomLeftLabel}</b>
      <b className={`${style.RightLabel} ${style.BottomLabel}`}>{bottomRightLabel}</b>
    </div>
    <Highlighter
      autoEscape
      highlightClassName="highlight"
      textToHighlight={label || ''}
      searchWords={highlight ? [highlight] : []}
      className={style.FontAwesomeTileLabel}
    />
  </div>;
}
